import { render, staticRenderFns } from "./resExportRecord.vue?vue&type=template&id=5f03bef8&scoped=true&"
import script from "./resExportRecord.vue?vue&type=script&lang=js&"
export * from "./resExportRecord.vue?vue&type=script&lang=js&"
import style1 from "./resExportRecord.vue?vue&type=style&index=1&id=5f03bef8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f03bef8",
  null
  
)

export default component.exports